module.exports = __webpack_public_path__ + "imgs/14a0936bd54fd18c22b5e7fb86ba26a3.gif";